import React from "react";
import {
  Zap,
  Battery,
  Sun,
  Wind,
  Gauge,
  Settings,
  BarChart,
  Shield,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Smart Grid Solutions",
    description:
      "Build intelligent grid management systems with real-time monitoring and optimization",
    icon: Zap,
  },
  {
    title: "Energy Management Platforms",
    description:
      "Develop comprehensive platforms for tracking and reducing energy consumption",
    icon: Battery,
  },
  {
    title: "Renewable Energy Systems",
    description:
      "Create software for solar, wind, and hybrid energy system management",
    icon: Sun,
  },
  {
    title: "IoT & Sensor Integration",
    description:
      "Connect smart meters, sensors, and devices for automated energy tracking",
    icon: Wind,
  },
  {
    title: "Predictive Analytics",
    description:
      "Implement AI-driven forecasting for demand planning and load balancing",
    icon: Gauge,
  },
  {
    title: "Asset Management",
    description:
      "Build systems to monitor and maintain energy infrastructure efficiently",
    icon: Settings,
  },
  {
    title: "Billing & Customer Portals",
    description:
      "Develop user-friendly billing systems and self-service customer portals",
    icon: BarChart,
  },
  {
    title: "Compliance & Reporting",
    description:
      "Ensure regulatory compliance with automated reporting and audit trails",
    icon: Shield,
  },
];

const STATS = [
  { value: "50+", label: "Energy Projects" },
  { value: "15M+", label: "Users Served" },
  { value: "30%", label: "Avg Cost Savings" },
  { value: "99.9%", label: "System Uptime" },
];

const EnergyIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="energy"
      industryTitle="Energy"
      industrySubtitle="Solutions"
      heroDescription="Powering the future with innovative technology solutions for energy management, smart grids, and sustainable energy platforms that drive efficiency and sustainability."
      themeColor="#f59e0b"
      themeColorLight="#fbbf24"
      themeGradient="linear-gradient(135deg, #78350f 0%, #92400e 50%, #f59e0b 100%)"
      HeroIcon={Zap}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1172&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default EnergyIndustryPage;
